import { connect } from 'react-redux';
import { AppState, AppThunkDispatch } from 'src/store';
import AgentPanel from './AgentPanel';
import { getChats, addChat } from './Agent.actions';
import { setActionMode } from './Agent.slice';
import type { AgentChatMessage } from './Agent.types';

const mapDispatchToProps = (dispatch: AppThunkDispatch) => {
  return {
    getChats() {
      dispatch(getChats());
    },
    addChat(message: { convoId: string, message: AgentChatMessage }) {
      dispatch(addChat(message));
    },
    setActionMode(mode: 'automatic' | 'user') {
      dispatch(setActionMode(mode));
    },
  };
};

const mapStateToProps = (state: AppState) => {
  const { agent, scope } = state;

  return {
    agentConfig: agent.viewDefn,
    conversations: agent.conversations,
    freeformAsyncState: agent.freeformAsyncState,
    actionMode: agent.actionMode,
    scope: {
      productMember: scope.selections.productMember,
      locationMember: scope.selections.locationMember,
    },
  };
};

type AgentPanelDispatchProps = ReturnType<typeof mapDispatchToProps>;
interface AgentPanelValueProps extends ReturnType<typeof mapStateToProps> { }
export type AgentPanelProps = AgentPanelDispatchProps & AgentPanelValueProps;

export default connect(mapStateToProps, mapDispatchToProps)(AgentPanel);
